export interface IPatchOperatioType {
    op: string;
    path: string;
    value: string | boolean;
}

export enum PatchOperatioType {
    Replace = "replace",
    Add = "add"
}